import React from 'react';
import { withFirebaseConsumer } from 'components/common/Firebase';
import withStyles from '@material-ui/core/styles/withStyles';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  email_and_password_text: {
    fontSize: 20,
    position: 'relative',
    top: 30,
    color: '#3c50b7c7'
  },
  paper: {
    marginTop: theme.spacing.unit * 14,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: '#7b64ab'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit
  },
  submit: {
    marginTop: theme.spacing.unit * 3
  },
  forgot_password: {
    textAlign: 'center'
  },

  error: {
    backgroundColor: 'orange'
  }
});

class ConfirmEmailVerificationBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationMessage: '',
      errorMessage: '',
      snackbarOpen: false
    };
  }

  handleFlashMessageClose = () => {
    this.setState({
      snackbarOpen: false
    });
  };

  componentDidMount() {
    this.props.firebase.auth.onAuthStateChanged(user => {
      if (user) {
        if (user.emailVerified) {
          this.setState({
            snackbarOpen: true,
            errorMessage: 'That email is already verified, thank you. '
          });

          setTimeout(() => {
            this.props.history.push('/');
          }, 3000);
        } else {
          this.props.firebase
            .auth
            .applyActionCode(this.props.oobCode)
            .then(resp => {
              this.setState({
                snackbarOpen: true,
                validationMessage: 'Your email is now verified, thank you.'
              });
            })
            .catch(error => {
              console.log(error.message);
              this.setState({
                snackbarOpen: true,
                errorMessage: error.message
              });
            });
        }
      } else {
        this.setState({
          snackbarOpen: true,
          errorMessage:
            'You have to be signed in to do that. Please sign in and click the verification email that you were sent'
        });
      }
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        {/* 

            This component contains no text. 
            All messages are presented to the user via a component that Material UI calls the "snackbar".  

          */}

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          open={this.state.snackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleFlashMessageClose}
          ContentProps={{
            'aria-describedby': 'message-id'
          }}
          message={
            <span id="message-id">
              {this.state.validationMessage || this.state.errorMessage}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleFlashMessageClose}
            >
              <CloseIcon />
            </IconButton>
          ]}
          bodystyle={{ backgroundColor: 'yellow' }}
        />
      </div>
    );
  }
}

export const ConfirmEmailVerification = compose(
  withStyles(styles),
  withFirebaseConsumer
)(withRouter(ConfirmEmailVerificationBase));
